'use strict';

/**
 * @author Maxim Seredkin
 */

import angular from 'angular';

export default ['$scope', '$uibModalInstance', 'milestone', 'milestoneFilters', 'def',
                function($scope, $modalInstance, milestone, milestoneFilters, def) {
                    $scope.ok = ok;
                    $scope.cancel = cancel;
                    $scope.isSelect = isSelect;

                    init();

                    // region Function

                    function init() {
                        // инициализация модели
                        $scope.milestone = angular.copy(milestone);
                        $scope.filters = angular.copy(milestoneFilters);
                        $scope.def = angular.copy(def);
                    }

                    function ok(milestone) {
                        $modalInstance.close(milestone);
                    }

                    function cancel() {
                        $modalInstance.dismiss();
                    }

                    function isSelect() {
                        return $scope.milestone != null && $scope.milestone.id != null;
                    }

                    // endregion
                }];
